import axios from 'axios'
/* 登录 Start*/
const authLogin = (params) => {

//   let res =this.$http.get("http://180.101.236.110:8081/inserts/logonNj", params);
// alert(JSON.stringify(res))
//   if(res.data.status===200){
//     sessionStorage.setItem("userId", res.message);
//     window.location.href="http://180.101.236.110:8081/inserts/userLoginWx?openid="+response.message;
//   }

  return axios({
    // url: 'http://180.101.236.110:8081/inserts/logonNj',
    url: 'http://weixin.njrsrc.cn/inserts/logonNj',
    method: 'get',
    params
  }).then((response) => {
    if(response.status==200){
      sessionStorage.setItem("userId", response.data.message);
      window.location.href="http://weixin.njrsrc.cn/inserts/userLoginWx?openid="+response.data.message+"&source=njapp";
    }else{
      alert('授权失败');
    }

  });

}
export default {
  authLogin,
}





// WEBPACK FOOTER //
// ./src/utils/logon.js